// src/modules/financials/components/RevenueTrendChart.jsx
import React from 'react';
import { Card, Empty } from 'antd';
import { Column } from '@ant-design/charts';
import { BarChartOutlined } from '@ant-design/icons';

const RevenueTrendChart = ({ data = [], loading = false }) => {
  if (!data || data.length === 0) {
    return (
      <Card
        title={<span><BarChartOutlined style={{ color: '#1890ff', marginRight: 8 }} />Revenue</span>}
        style={{ borderRadius: 12, border: '1px solid #f0f0f0' }}
        loading={loading}
      >
        <Empty description="No revenue data for the selected period" />
      </Card>
    );
  }

  const config = {
    data,
    xField: 'date',
    yField: 'revenue',
    style: { radiusTopLeft: 4, radiusTopRight: 4, fill: '#1890ff' },
    label: false,
    tooltip: {
      items: [
        (d) => ({
          name: 'Revenue',
          value: `₹${Number(d.revenue || 0).toLocaleString('en-IN')} (${d.billCount || 0} bills)`,
        }),
      ],
    },
    axis: {
      y: { labelFormatter: (v) => `₹${Number(v).toLocaleString('en-IN')}` },
    },
  };

  return (
    <Card
      title={<span><BarChartOutlined style={{ color: '#1890ff', marginRight: 8 }} />Revenue</span>}
      style={{ borderRadius: 12, border: '1px solid #f0f0f0', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
      loading={loading}
    >
      <Column {...config} height={320} />
    </Card>
  );
};

export default RevenueTrendChart;
